export default __webpack_public_path__ + "static/media/meal-3.13c73770.svg";